import { Redirect, Route } from 'react-router-dom'
import { NoAccessPage } from '../../containers'
import useCatapultAuth from '../../hooks/useCatapultAuth'
import { NAV_LINKS } from '../../constants/NavConstants'

const mapStateToProps = ({ user }) => ({ hasAccess: user.hasAccess })

const NoAccessRoute = connect(mapStateToProps)(({ component: Component, hasAccess, ...rest }) => {
  const { isAuthed } = useCatapultAuth()
  return isAuthed && !hasAccess ? (
    <Component {...rest} />
  ) : (
    <Redirect to={{ pathname: NAV_LINKS.redirect, from: NAV_LINKS.noaccess }} />
  )
})

export default () => (
  <Route
    path={NAV_LINKS.noaccess}
    render={props => <NoAccessRoute {...props} component={NoAccessPage} />}
  />
)
